import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle1" }
const _hoisted_2 = { class: "q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_requested_at = _resolveComponent("requested-at")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_info_section = _resolveComponent("info-section")!
  const _component_reminders_section = _resolveComponent("reminders-section")!
  const _component_cancel_request_section = _resolveComponent("cancel-request-section")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: `${_ctx.platform} Posts Requested`,
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, " The client has been requested to import their " + _toDisplayString(_ctx.platform) + " posts into Private Footprint. ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_requested_at, { request: _ctx.request }, null, 8, ["request"])
      ]),
      _createVNode(_component_q_separator, { class: "q-my-md" }),
      _createVNode(_component_info_section, { platform: _ctx.platform }, null, 8, ["platform"]),
      _createVNode(_component_q_separator, { class: "q-my-md" }),
      _createVNode(_component_reminders_section, {
        request: _ctx.reconnectRequest,
        "onUpdate:request": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reconnectRequest) = $event)),
        platform: _ctx.platform
      }, null, 8, ["request", "platform"]),
      _createVNode(_component_q_separator, { class: "q-my-md" }),
      _createVNode(_component_cancel_request_section, {
        request: _ctx.request,
        platform: _ctx.platform,
        onCanceled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hide()))
      }, null, 8, ["request", "platform"])
    ]),
    _: 1
  }, 8, ["title"]))
}